import {
  ACDTYPE_TEXT,
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_SEPARATOR,
  ACDTYPE_IMAGE_ONLY,
  ACDTYPE_IMAGE_ARR
} from "./ACDTypes";

import {
  mergeTextItemWith,
  mergeTextOnlyItemWith,
  mergeImageWith,
  mergeVideoWith,
  mergeAudioWith,
  mergeSepWith,
  mergeImageOnlyItemWith,
  mergeImageArrWith
} from "./privateACDType";

export function mergeACDItem(mainItem, item2) {
  if (mainItem == null || item2 == null) {
    throw Error("item cannot be null");
  }

  if (mainItem.dataType == null || item2.dataType == null) {
    throw Error("item is not ACD item");
  }

  if (mainItem.dataType < item2.dataType) {
    return mergeACDItemAction(mainItem, item2, false);
  } else {
    return mergeACDItemAction(item2, mainItem, true);
  }
}

function mergeACDItemAction(item1, item2, reversed) {
  switch (item1.dataType) {
    case ACDTYPE_TEXT:
      return mergeTextItemWith(item1, item2, reversed);
    case ACDTYPE_TEXT_ONLY:
      return mergeTextOnlyItemWith(item1, item2, reversed);
    case ACDTYPE_IMAGE:
      return mergeImageWith(item1, item2, reversed);
    case ACDTYPE_VIDEO:
      return mergeVideoWith(item1, item2, reversed);
    case ACDTYPE_AUDIO:
      return mergeAudioWith(item1, item2, reversed);
    case ACDTYPE_SEPARATOR:
      return mergeSepWith(item1, item2, reversed);
    case ACDTYPE_IMAGE_ONLY:
      return mergeImageOnlyItemWith(item1, item2, reversed);
    case ACDTYPE_IMAGE_ARR:
      return mergeImageArrWith(item1, item2, reversed);
    default:
      throw Error("unknown data type");
  }
}

export function getACDTypeApiText(acdType) {
  switch (acdType) {
    case ACDTYPE_TEXT:
      return "text";
    case ACDTYPE_TEXT_ONLY:
      return "text";
    case ACDTYPE_IMAGE:
      return "image";
    case ACDTYPE_VIDEO:
      return "video";
    case ACDTYPE_AUDIO:
      return "audio";
    case ACDTYPE_SEPARATOR:
      return "separator";
    case ACDTYPE_IMAGE_ONLY:
      return "image";
    case ACDTYPE_IMAGE_ARR:
      return "image_items";
    default:
      return null;
  }
}

export function getClientACDType(acdTypeText, isMeta) {
  switch (acdTypeText) {
    case "text":
      return isMeta ? ACDTYPE_TEXT_ONLY : ACDTYPE_TEXT;
    case "image":
      return isMeta ? ACDTYPE_IMAGE_ONLY : ACDTYPE_IMAGE;
    case "video":
      return ACDTYPE_VIDEO;
    case "audio":
      return ACDTYPE_AUDIO;
    case "separator":
      return ACDTYPE_SEPARATOR;
    case "image_items":
      return ACDTYPE_IMAGE_ARR;
    default:
      return null;
  }
}
